import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "profile-title" }
const _hoisted_3 = { class: "profile-name" }
const _hoisted_4 = {
  key: 0,
  class: "s-text-description text-grey"
}
const _hoisted_5 = {
  key: 1,
  class: "s-text-description text-grey"
}

import { computed } from 'vue';
import { UserProfileBare } from 'SharedDir/declarations/user-profiles';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { isProfileOrganization } from 'SharedDir/common/composables/profile/useProfileForm';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'UserProfileItem' },
  __name: 'UserProfileItem',
  props: {
    data: {}
  },
  setup(__props: any) {


const props = __props;

const profileName = computed(() => props.data?.name ?? '');

const isOrganization = computed((): boolean => {
  return isProfileOrganization(props.data);
});

const profileInn = computed(() => {
  const defaultEmpty = '-';
  if (isOrganization.value) {
    return props.data.organization?.inn ?? defaultEmpty;
  }

  return props.data?.user?.inn ?? defaultEmpty;
});

const profileType = computed(() => {
  return isOrganization.value ? 'Организация' : 'Физическое лицо';
});

const { isMobile } = useDeviceSize();

return (_ctx: any,_cache: any) => {
  const _component_s_icon = _resolveComponent("s-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "profile-picker_profile",
    title: profileName.value
  }, [
    _createVNode(_component_s_icon, {
      name: "app:user-mini",
      color: "brand",
      size: _unref(isMobile) ? '30' : '44'
    }, null, 8, ["size"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(profileName.value), 1),
      (profileInn.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(profileInn.value), 1))
        : _createCommentVNode("", true),
      (profileType.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(profileType.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_s_icon, {
      name: "app:arrow-normal-right",
      class: "profile-btn-icon",
      color: "brand",
      size: _unref(isMobile) ? '16' : '24'
    }, null, 8, ["size"])
  ], 8, _hoisted_1))
}
}

})